import {
  FunctionComponent,
  useEffect,
  useState,
  useRef
} from "react";
import {
  Container,
  TextField,
  Button,
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  MenuItem,
  TablePagination,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  RadioGroup,
  Radio,
  FormControl,
  FormLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik, FormikProvider, Form } from "formik";
import * as Yup from "yup";
import SessionStorageService from "../../../services/StorageService";
import { useNavigate } from "react-router-dom";

import { displayValue } from "../../../helpers/TodayDate";
import AbonelikDevir, {
  AboneDevirBasvuruSaveRequest,
} from "../../../apis/OB/SaveApi/AbonelikDevir";
import AboneTipiListeAPI from "../../../apis/OB/Get/AboneTipiListeAPI";
import BolgeKoduAPI from "../../../apis/OB/Get/BolgeKoduAPI";
import MahalleListeAPI from "../../../apis/OB/Get/MahalleListeAPI";
import CaddeSokakAPI from "../../../apis/OB/Get/CaddeSokakAPI";
import AboneListeAPI from "../../../apis/OB/Get/AboneListeAPI";
import SuDisKapiListeAPI from "../../../apis/OB/Get/SuDisKapiListeAPI";
import SuIcKapiListeApi from "../../../apis/OB/Get/SuIcKapiListeApi";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import DocumentTable from "../../../components/OB/BelgeYukleme";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";
import { toast } from "react-toastify";
import DysAPI from "../../../apis/DysAPI";
import WebSabitler from "../../../apis/WebSabitler";

const AbonelikDevirBasvurusu: FunctionComponent = () => {
  const [checkedIndex, setCheckedIndex] = useState<number | null>(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);
  const [data, setData] = useState<any[]>([]);
  const [aboneTipiList, setAboneTipiList] = useState<any[]>([]);
  const [bolgeKoduDatas, setBolgeKoduDatas] = useState<any[]>([]);
  const [mahalleKoduDatas, setMahalleKoduDatas] = useState<any[]>([]);
  const [caddeSokakDatas, setCaddeSokakDatas] = useState<any[]>([]);
  const [disKapiDatas, setDisKapiDatas] = useState<any[]>([]);
  const [icKapiDatas, setIcKapiDatas] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [popupContent, setPopupContent] = useState<string>("");
  const [isPopupVisible, setIsPopupVisible] = useState<boolean>(false);
  const [isLoad, setIsLoad] = useState(true);
  const [userControlPopup, setUserControlPopup] = useState(false);

  const [documents, setDocuments] = useState<any[]>([]);
  const [docsLoaded, setDocsLoaded] = useState<boolean>(false);
  const documentTableRef = useRef<HTMLDivElement | null>(null);

  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  const [mesafeliSozlesmeBase64, setMesafeliSozlesmeBase64] = useState<string | null>(null);
  const [sozlesmeOnaylandi, setSozlesmeOnaylandi] = useState<boolean>(false);
  const [sozlesmePopupOpen, setSozlesmePopupOpen] = useState<boolean>(false);
  const [sozlesmePdfUrl, setSozlesmePdfUrl] = useState<string | null>(null);
  const [sozlesmeScrolledToBottom, setSozlesmeScrolledToBottom] = useState<boolean>(false);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  // Sorgulama yöntemi state'leri
  const [sorgulamaYontemi, setSorgulamaYontemi] = useState<string>("");
  const [adim, setAdim] = useState<number>(1);
  const [aboneNoInput, setAboneNoInput] = useState<string>("");
  const [sayacNoInput, setSayacNoInput] = useState<string>("");

  const handleSorgulamaYontemiChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSorgulamaYontemi(event.target.value);
  };

  const handleDevamEt = () => {
    if (sorgulamaYontemi === "") {
      openPopup("Lütfen bir sorgulama yöntemi seçiniz.");
      return;
    }
    setAdim(2);
  };

  const handleGeriDon = () => {
    setAdim(1);
    setSorgulamaYontemi("");
    setData([]);
    setCheckedIndex(null);
    setAboneTipi(null);
    setAboneNoInput("");
    setSayacNoInput("");
    setCurrentPage(0);
  };

  const handleSozlesmeScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - scrollTop - clientHeight < 50) {
      setSozlesmeScrolledToBottom(true);
    }
  };

  const handleCloseSozlesmePopup = () => {
    setSozlesmePopupOpen(false);
    setSozlesmeScrolledToBottom(false);
    if (sozlesmePdfUrl) {
      window.URL.revokeObjectURL(sozlesmePdfUrl);
      setSozlesmePdfUrl(null);
    }
  };

  const handleUpdateDocuments = (updatedDocuments: any) => {
    setDocuments(updatedDocuments);
  };
  useEffect(() => {
    setDocsLoaded(false);

    DysAPI.obBasvuruTanimBelgeList({ rfObBasvuruTanim: 301 })
      .then((res: any) => {
        console.log("Belge listesi response:", res.data);

        const list = (res?.data ?? []).map((b: any, idx: number) => {
          const zorunlu = (b.zorunluEh)
            .toString();

          return {
            id: b.sqId,
            documentName: b.belgeAdi,
            isRequired: ["E"].includes(zorunlu),
            fileName: "",
            file: null,
          };
        });


        setDocuments(list);
      })
      .catch((err: any) => {
        console.error("Belge listesi hatası:", err);
        setDocuments((prevDocs: any[]) =>
          prevDocs.map((doc) => ({
            ...doc,
            file: null,
            fileName: "",
          }))
        );
      })
      .finally(() => {
        setDocsLoaded(true);
      });
  }, []);

  useEffect(() => {
    const fetchSabitler = async () => {
      try {
        const response = await WebSabitler.getWebSabitler();
        if (response?.data?.devirBsvruMesafeliSozlesmeBase64) {
          setMesafeliSozlesmeBase64(response.data.devirBsvruMesafeliSozlesmeBase64);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchSabitler();
  }, []);

  const navigate = useNavigate();
  let user = SessionStorageService.getUserInfo();

  const closeUserControlPopup = () => {
    setUserControlPopup(false);
    navigate(-1);
  };

  useEffect(() => {
    if (user == null) {
      setUserControlPopup(true);
    } else {
      setIsLoad(false);
    }
  }, []);

  const openPopup = (content: string) => {
    setPopupContent(content);
    setIsPopupVisible(true);
  };

  const closePopup = () => {
    setPopupContent("");
    setPopupAciklama("");
    setIsPopupVisible(false);
    if (kayitBasarili) {
      setCheckedIndex(null);
      setAboneTipi(null)
    }
    setKayitBasarili(false);


  };

  useEffect(() => {
    if (user) {
      AboneTipiListeAPI.getAboneTipiListe()
        .then((res) => {
          setAboneTipiList(res.data);
        })
        .catch((err) => {
          console.error(err);
        });

      BolgeKoduAPI.getBolgeKoduiste(undefined)
        .then((res) => {
          setBolgeKoduDatas(res.data);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, []);

  // Adres ile sorgulama
  const fetchData = () => {
    if (
      formik.values.bolgeKodu !== -1 &&
      formik.values.mahalleKodu !== -1 &&
      formik.values.caddeSokakKodu !== -1 &&
      formik.values.disKapiNo !== -1
    ) {
      setIsLoading(true);
      setCheckedIndex(null);
      setAboneTipi(null);
      AboneListeAPI.getAboneListe(
        formik.values.bolgeKodu,
        formik.values.mahalleKodu,
        formik.values.caddeSokakKodu,
        formik.values.disKapiNo.toString(),
        formik.values.icKapiNo === -1
          ? undefined
          : formik.values.icKapiNo.toString()
      )
        .then((res) => {
          setData(res.data);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      openPopup(
        "Bölge, Mahalle, Cadde/Sokak, Dış Kapı No alanları zorunludur."
      );
    }
  };

  // Abone numarası ile sorgulama
  const fetchDataByAboneNo = () => {
    if (!aboneNoInput || aboneNoInput.trim() === "") {
      openPopup("Lütfen abone numarası giriniz.");
      return;
    }
    setIsLoading(true);
    setCheckedIndex(null);
    setAboneTipi(null);
    AboneListeAPI.getAboneListe(
      undefined, undefined, undefined, undefined, undefined,
      Number(aboneNoInput), undefined
    )
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setData(res.data);
        } else {
          setData([]);
          openPopup("Girilen abone numarasına ait kayıt bulunamadı.");
        }
      })
      .catch((err) => {
        console.error(err);
        openPopup("Girilen abone numarasına ait kayıt bulunamadı.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Sayaç numarası ile sorgulama
  const fetchDataBySayacNo = () => {
    if (!sayacNoInput || sayacNoInput.trim() === "") {
      openPopup("Lütfen sayaç numarası giriniz.");
      return;
    }
    setIsLoading(true);
    setCheckedIndex(null);
    setAboneTipi(null);
    AboneListeAPI.getAboneListe(
      undefined, undefined, undefined, undefined, undefined,
      undefined, sayacNoInput
    )
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setData(res.data);
        } else {
          setData([]);
          openPopup("Girilen sayaç numarasına ait kayıt bulunamadı.");
        }
      })
      .catch((err) => {
        console.error(err);
        openPopup("Girilen sayaç numarasına ait kayıt bulunamadı.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Ara butonuna basıldığında sorgulama yöntemine göre çağrı yap
  const handleAra = () => {
    if (sorgulamaYontemi === "aboneNo") {
      fetchDataByAboneNo();
    } else if (sorgulamaYontemi === "sayacNo") {
      fetchDataBySayacNo();
    } else {
      fetchData();
    }
  };

  const [aboneTipi, setAboneTipi] = useState<any>(null);

  const [popupAciklama, setPopupAciklama] = useState("");
  const [kayitBasarili, setKayitBasarili] = useState(false);
  const formik = useFormik({
    initialValues: {
      bolgeKodu: -1,
      mahalleKodu: -1,
      caddeSokakKodu: -1,
      disKapiNo: -1,
      icKapiNo: -1,
    },
    validationSchema: Yup.object({
      bolgeKodu: Yup.number().required("Bölge Kodu gereklidir"),
      mahalleKodu: Yup.number().required("Mahalle Kodu gereklidir"),
      caddeSokakKodu: Yup.number().required("Cadde/Sokak Kodu gereklidir"),
      disKapiNo: Yup.number().required("Dış Kapı No gereklidir"),
    }),
    onSubmit: (values, { resetForm }) => {
      setIsSubmitted(true);

      const missingDocuments = documents
        .filter(doc => doc.isRequired) // zorunlu belgeler
        .filter(doc => !doc.fileName);     // henüz yüklenmemiş olanlar

      if (missingDocuments.length > 0) {
        const missingDocNames = missingDocuments.map(d => d.documentName).join(", ");
        toast.error(`Lütfen şu zorunlu belgeleri yükleyin: ${missingDocNames}`);
        documentTableRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
        return; // başvuru burada durur
      }

      if (checkedIndex === null) {
        setKayitBasarili(true);//sonra düzenlenecek
        openPopup("Lütfen bir abone seçiniz.");
        return;
      }

      if (mesafeliSozlesmeBase64 && !sozlesmeOnaylandi) {
        toast.error("Lütfen mesafeli sözleşmeyi okuyup onaylayınız.");
        return;
      }
      let aboneTipiKodu: any = aboneTipiList.find(
        (x) => x.aboneTipiAdi === aboneTipi
      );
      const request = new AboneDevirBasvuruSaveRequest(
        301,
        user?.sicilKodu,
        checkedIndex,
        aboneTipiKodu.aboneTipiKodu
      );
      console.log(request);
      setLoadingSubmit(true);
      AbonelikDevir.saveAbonelikDevirBasvuruSave(request)
        .then(async (response) => {
          if (response.data.sonuc === 0) {
            let basvuruNo = response.data.basvuruNo;

            // DYS API'yi çağır
            try {
              // Sadece dosyası olanları al
              const filesToSend = documents.filter((doc: any) => !!doc.file);

              if (filesToSend.length > 0) {
                const formData = new FormData();

                filesToSend.forEach((doc: any) => {
                  formData.append("files", doc.file, doc.file.name);
                  formData.append("rfObBasvuruTanimBelge", String(doc.id));
                });

                formData.append("basvuruTuru", String(-5 || 0));
                formData.append("basvuruId", String(basvuruNo));
                formData.append("folderName", "AKOS");
                formData.append("kurumId", "1");
                formData.append("versionable", "1");

                const response = await DysAPI.upload(formData);
                toast.warning(response.message);
              } else {
                // Burada return yok — sadece DYS çağrısını atlıyoruz.

              }
            } catch (error: any) {
              toast.error("DYS upload hazırlama hatası:", error);
            }


            setPopupAciklama("İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " + basvuruNo);
            resetForm();
            setSozlesmeOnaylandi(false);
            setIsSubmitted(false);
            setKayitBasarili(true);
            setDocuments((prevDocs: any[]) =>
              prevDocs.map((doc) => ({
                ...doc,
                file: null,
                fileName: "",
              }))
            );
          } else {
            setPopupAciklama(response.data.sonucAciklama);
          }
        })
        .catch((error) => {
          console.error(error);
          const backendMessage = error?.response?.data?.sonucAciklama || error?.response?.data?.message;
          setPopupAciklama(
            backendMessage || "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz."
          );
        })
        .finally(() => {
          setIsPopupVisible(true);
          setLoadingSubmit(false);
        });
    },
  });
  useEffect(() => {
    if (formik.values.bolgeKodu !== -1) {
      MahalleListeAPI.getMahalleListe(formik.values.bolgeKodu, undefined)
        .then((res) => {
          setMahalleKoduDatas(res.data);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [formik.values.bolgeKodu]);

  useEffect(() => {
    if (formik.values.mahalleKodu !== -1) {
      CaddeSokakAPI.getCaddeSokakListe(undefined, formik.values.mahalleKodu)
        .then((res) => {
          setCaddeSokakDatas(res.data);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [formik.values.mahalleKodu]);

  useEffect(() => {
    if (
      formik.values.mahalleKodu !== -1 &&
      formik.values.caddeSokakKodu !== -1
    ) {
      SuDisKapiListeAPI.getSuDisKapiListe(
        formik.values.bolgeKodu,
        formik.values.mahalleKodu,
        formik.values.caddeSokakKodu
      )
        .then((res) => {
          setDisKapiDatas(res.data);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [formik.values.caddeSokakKodu]);

  useEffect(() => {
    if (formik.values.mahalleKodu !== -1 && formik.values.disKapiNo !== -1) {
      SuIcKapiListeApi.getSuIcKapiListe(
        formik.values.disKapiNo.toString(),
        formik.values.mahalleKodu,
        formik.values.caddeSokakKodu
      )
        .then((res) => {
          setIcKapiDatas(res.data);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [formik.values.disKapiNo]);
  const handleChangePage = (event: unknown, newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  return isLoad ? (
    <>
      <div className="d-flex align-self-strech justify-content-center align-items-center">
        {" "}
        <CircularProgress />
      </div>
      {userControlPopup ? (
        <AciklamaAndUserControlPopup
          open={userControlPopup}
          handleClose={closeUserControlPopup}
          isUserControlPopUp={true}
          description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
        />
      ) : null}
    </>
  ) : (
    <>
      {/* Adım 1: Sorgulama Yöntemi Seçimi */}
      {adim === 1 && (
        <Card className="w-100">
          <CardContent>
            <FormControl component="fieldset" sx={{ width: '100%' }}>
              <FormLabel component="legend">Sorgulama Yöntemi</FormLabel>
              <RadioGroup
                value={sorgulamaYontemi}
                onChange={handleSorgulamaYontemiChange}
              >
                <FormControlLabel value="aboneNo" control={<Radio />} label="Abone Numarası ile Sorgulama" />
                <FormControlLabel value="sayacNo" control={<Radio />} label="Sayaç Numarası ile Sorgulama" />
                <FormControlLabel value="adres" control={<Radio />} label="Adres ile Sorgulama" />
              </RadioGroup>
            </FormControl>
            <Grid container justifyContent="center" sx={{ mt: 2 }}>
              <Button variant="contained" onClick={handleDevamEt}>
                Devam Et
              </Button>
            </Grid>
          </CardContent>
        </Card>
      )}

      {/* Adım 2: Arama Formu ve Sonuçlar */}
      {adim === 2 && (
        <FormikProvider value={formik}>
          <Form>
            <Card className="w-100">
              <CardContent>

                <Grid container spacing={2}>

                  {/* Abone Numarası ile Sorgulama */}
                  {sorgulamaYontemi === "aboneNo" && (
                    <Grid item xs={12} md={4}>
                      <TextField
                        size="small"
                        fullWidth
                        label="Abone Numarası"
                        value={aboneNoInput}
                        onChange={(e) => setAboneNoInput(e.target.value)}
                      />
                    </Grid>
                  )}

                  {/* Sayaç Numarası ile Sorgulama */}
                  {sorgulamaYontemi === "sayacNo" && (
                    <Grid item xs={12} md={4}>
                      <TextField
                        size="small"
                        fullWidth
                        label="Sayaç Numarası"
                        value={sayacNoInput}
                        onChange={(e) => setSayacNoInput(e.target.value)}
                      />
                    </Grid>
                  )}

                  {/* Adres ile Sorgulama */}
                  {sorgulamaYontemi === "adres" && (
                    <>
                      <Grid item xs={12} md={4}>
                        <TextField
                          size="small"
                          select
                          fullWidth
                          label="Bölge Kodu"
                          value={formik.values.bolgeKodu}
                          onChange={formik.handleChange}
                          name="bolgeKodu"
                          error={
                            formik.touched.bolgeKodu &&
                            Boolean(formik.errors.bolgeKodu)
                          }
                          helperText={
                            formik.touched.bolgeKodu && formik.errors.bolgeKodu
                          }
                        >
                          <MenuItem value={-1}>Bölge Adı</MenuItem>
                          {bolgeKoduDatas.map((item, index) => (
                            <MenuItem key={index} value={item.bolgeKodu}>
                              {item.bolgeAdi}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextField
                          size="small"
                          select
                          fullWidth
                          label="Mahalle Kodu"
                          value={formik.values.mahalleKodu}
                          onChange={formik.handleChange}
                          name="mahalleKodu"
                          error={
                            formik.touched.mahalleKodu &&
                            Boolean(formik.errors.mahalleKodu)
                          }
                          helperText={
                            formik.touched.mahalleKodu && formik.errors.mahalleKodu
                          }
                        >
                          <MenuItem value={-1}>Mahalle</MenuItem>
                          {mahalleKoduDatas.map((item, index) => (
                            <MenuItem key={index} value={item.mahalleKodu}>
                              {item.mahalleAdi}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextField
                          size="small"
                          select
                          fullWidth
                          label="Cadde/Sokak Kodu"
                          value={formik.values.caddeSokakKodu}
                          onChange={formik.handleChange}
                          name="caddeSokakKodu"
                          error={
                            formik.touched.caddeSokakKodu &&
                            Boolean(formik.errors.caddeSokakKodu)
                          }
                          helperText={
                            formik.touched.caddeSokakKodu &&
                            formik.errors.caddeSokakKodu
                          }
                        >
                          <MenuItem value={-1}>Cadde/Sokak</MenuItem>
                          {caddeSokakDatas.map((item, index) => (
                            <MenuItem key={index} value={item.caddeSokakKodu}>
                              {item.caddeSokakAdi}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          size="small"
                          select
                          fullWidth
                          label="Dış Kapı No"
                          value={formik.values.disKapiNo}
                          onChange={formik.handleChange}
                          name="disKapiNo"
                          error={
                            formik.touched.disKapiNo &&
                            Boolean(formik.errors.disKapiNo)
                          }
                          helperText={
                            formik.touched.disKapiNo && formik.errors.disKapiNo
                          }
                        >
                          <MenuItem value={-1}>Dış Kapı No</MenuItem>
                          {disKapiDatas.map((item, index) => (
                            <MenuItem key={index} value={item.disKapiNo}>
                              {item.disKapiNo}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          size="small"
                          select
                          fullWidth
                          label="İç Kapı No"
                          value={formik.values.icKapiNo}
                          onChange={formik.handleChange}
                          name="icKapiNo"
                          error={
                            formik.touched.icKapiNo && Boolean(formik.errors.icKapiNo)
                          }
                          helperText={
                            formik.touched.icKapiNo && formik.errors.icKapiNo
                          }
                        >
                          <MenuItem value={-1}>İç Kapı No</MenuItem>
                          {icKapiDatas.map((item, index) => (
                            <MenuItem key={index} value={item.icKapiNo}>
                              {item.icKapiNo}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    </>
                  )}

                  <Grid item xs={12} className="d-flex justify-content-between">
                    {/* Sol: Geri */}
                    <Button variant="outlined" onClick={handleGeriDon}>
                      Geri
                    </Button>
                    <Button variant="contained" onClick={handleAra}>
                      Ara
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    {isLoading ? (
                      <Typography>Loading...</Typography>
                    ) : (
                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell></TableCell>
                              <TableCell>Abone No</TableCell>
                              <TableCell>Abone Tipi</TableCell>
                              <TableCell>Sayaç Markası</TableCell>
                              <TableCell>Sayaç No</TableCell>
                              <TableCell>Adres</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {data.length > 0 ? data
                              .slice(
                                currentPage * rowsPerPage,
                                currentPage * rowsPerPage + rowsPerPage
                              )
                              .map((item, index) => (
                                <TableRow key={index}>
                                  <TableCell>
                                    <Checkbox
                                      checked={
                                        checkedIndex === Number(item.aboneNo)
                                      }
                                      onChange={() => {
                                        if (
                                          checkedIndex === Number(item.aboneNo)
                                        ) {
                                          setCheckedIndex(null);
                                          setAboneTipi(null);
                                        } else {
                                          setCheckedIndex(Number(item.aboneNo));
                                          setAboneTipi(item.aboneTipi);
                                        }
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell>{item.aboneNo}</TableCell>
                                  <TableCell>{item.aboneTipi}</TableCell>
                                  <TableCell>
                                    {displayValue(item.sayacMarkası)}
                                  </TableCell>
                                  <TableCell>{item.sayacNo}</TableCell>
                                  <TableCell>{item.adres}</TableCell>
                                </TableRow>
                              )) : <TableRow><TableCell colSpan={6}>Kayıt bulunamadı!</TableCell></TableRow>}
                          </TableBody>
                        </Table>
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 25]}
                          component="div"
                          count={data.length}
                          rowsPerPage={rowsPerPage}
                          page={currentPage}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                      </TableContainer>
                    )}
                  </Grid>
                </Grid>

              </CardContent>
            </Card>
            <Grid container>
              {mesafeliSozlesmeBase64 && (
                <Grid item xs={12}>
                  <div style={{ marginTop: 16, marginBottom: 8 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={sozlesmeOnaylandi}
                          color="primary"
                          readOnly
                        />
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        if (mesafeliSozlesmeBase64) {
                          const byteCharacters = atob(mesafeliSozlesmeBase64);
                          const byteNumbers = new Array(byteCharacters.length);
                          for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                          }
                          const byteArray = new Uint8Array(byteNumbers);
                          const blob = new Blob([byteArray], { type: 'application/pdf' });
                          const url = window.URL.createObjectURL(blob);
                          setSozlesmePdfUrl(url);
                          setSozlesmePopupOpen(true);
                        }
                      }}
                      sx={{ cursor: 'pointer' }}
                      label={
                        <span>
                          <Link
                            component="span"
                            underline="always"
                          >
                            Mesafeli Sözleşme
                          </Link>
                          'yi okudum ve kabul ediyorum.
                        </span>
                      }
                    />
                    {isSubmitted && !sozlesmeOnaylandi && (
                      <span style={{ color: '#d32f2f', fontSize: '0.75rem', display: 'block', marginLeft: 32 }}>
                        Mesafeli sözleşmeyi onaylamanız gerekmektedir.
                      </span>
                    )}
                  </div>
                </Grid>
              )}
              <Grid item xs={12}>
                <div ref={documentTableRef}>
                  {!docsLoaded ? (
                    <div className="d-flex justify-content-center my-2"><CircularProgress size={24} /></div>
                  ) : (
                    <DocumentTable rows={documents} onUpdateDocuments={handleUpdateDocuments} />
                  )}
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button color="primary" type="submit">
                  Gönder
                </Button>
                {loadingSubmit && (
                  <div
                    style={{
                      position: "fixed",
                      inset: 0,
                      background: "rgba(255,255,255,0.6)",
                      zIndex: 1300,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress />
                  </div>
                )}
              </Grid>

            </Grid>
          </Form>
        </FormikProvider>
      )}
      {isPopupVisible && (
        <BilgilendirmePopup
          basvuruTuruId={-5}
          isSorunBildirPopup={!kayitBasarili}
          closePopup={closePopup}
          open={isPopupVisible}
          editDescription={popupAciklama !== "" ? popupAciklama : popupContent}
        />
      )}
      <Dialog
        open={sozlesmePopupOpen}
        onClose={handleCloseSozlesmePopup}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Mesafeli Sözleşme
          <IconButton onClick={handleCloseSozlesmePopup}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          onScroll={handleSozlesmeScroll}
          dividers
          sx={{ maxHeight: '65vh', p: 0 }}
        >
          {sozlesmePdfUrl && (
            <div style={{ overflow: 'hidden', width: '100%', height: '800px' }}>
              <iframe
                src={`${sozlesmePdfUrl}#toolbar=0&navpanes=0`}
                width="100%"
                style={{ border: 'none', height: 'calc(100% + 52px)', marginTop: '-52px' }}
                title="Mesafeli Sözleşme"
              />
            </div>
          )}
          <Typography variant="body2" sx={{ textAlign: 'center', color: 'text.secondary', py: 2 }}>
            Sözleşmenin tamamını okuduktan sonra onaylayabilirsiniz.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            disabled={!sozlesmeScrolledToBottom}
            onClick={() => {
              setSozlesmeOnaylandi(true);
              handleCloseSozlesmePopup();
            }}
            variant="contained"
            color="primary"
          >
            Okudum ve Onaylıyorum
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AbonelikDevirBasvurusu;
